import React, { useContext } from 'react';
import {
  Badge,
  Card,
  Container,
  styled,
} from '@mui/material';
import styles from 'Global/Styles/StickToBottom.module.scss';
import Allblack from 'Global/Styles/BottomBar.module.scss';
import resnsive from 'Global/Styles/Responsive.BottomBar.module.scss';
import {
  Home,
  Notifications,
  Payment,
  Phone,
  Settings,
} from '@mui/icons-material';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import useStateBank from './StateBank/useStateBank';
import OptionsDrawer from './Components/OptionsDrawer';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const BottomBar = () => {
  const markazSettings =
    useContext(GlobalContext)?.appConfig;
  const GlobalConstants = useContext(GlobalContext);
  const IsDrawerOpen =
    useContext(GlobalContext)?.settingDrawerOpen;
  const setDrawerOpen =
    useContext(GlobalContext)?.setSettingDrawerOpen;
  const navigate = GlobalConstants.navigate;
  const data = useStateBank();
  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: 'red',
      color: 'white',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      cursor: 'pointer',
      marginTop: '.5em',
    },
  }));

  return (
    <React.Fragment>
      <footer
        className={`${styles.stickBottom} ${resnsive.responsiveBottomBar}`}
      >
        <Card
          sx={{
            width: '70%',
            borderRadius: '2em',
          }}
          elevation={5}
        >
          <nav className="bottombar-layout-color">
            <ul
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                listStyle: 'none',
                paddingInline: '1em',
              }}
              className={Allblack.Allblack}
            >
              <li aria-label="تماس با ما">
                <a
                  href={`tel:${markazSettings[1]?.Value}`}
                  style={{ color: 'white' }}
                >
                  <Phone
                    fontSize="large"
                    sx={{ cursor: 'pointer' }}
                  />
                </a>
              </li>
              {/* <li
    aria-label="تنظیمات"
    onClick={() => setDrawerOpen((prev) => !prev)}
  >
    <Settings fontSize="large" sx={{ cursor: "pointer" }} />
  </li> */}
              {/* <li aria-label="کیف پول">
    <Payment fontSize="large" sx={{ cursor: "pointer" }} />
  </li> */}
              <span
                onClick={() =>
                  navigate({ pathname: '/main' })
                }
                style={{ cursor: 'pointer' }}
              >
                <Home
                  fontSize="large"
                  sx={{ cursor: 'pointer' }}
                />
              </span>
              <StyledBadge
                badgeContent={data?.MessageList?.length}
                sx={{ color: 'white' }}
                onClick={() =>
                  navigate('/messages', { state: { data } })
                }
              >
                <li
                  style={{ cursor: 'pointer' }}
                  aria-label="اعلان ها"
                >
                  <Notifications
                    fontSize="large"
                    sx={{ cursor: 'pointer' }}
                  />
                </li>
              </StyledBadge>
            </ul>
          </nav>
        </Card>
      </footer>
      <OptionsDrawer
        IsDrawerOpen={IsDrawerOpen}
        setDrawerOpen={setDrawerOpen}
      />
    </React.Fragment>
  );
};

export default BottomBar;
